/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/base/drop-menu/drop-menu');
require('components/base/checkbox/checkbox');
require('components/base/btn/btn');
require('components/base/form-area/form-area');
require('components/base/pop/pop');
require('components/base/upload/upload')
require('components/common/drop-menu-input/drop-menu-input')
require('./post-add.scss');
const ajaxHttp = require('appUtil/ajaxHttp');
const template = require('./post-add.tpl');
const store = require('appVuex/store');
const tip = require('components/base/pop/tip');
const { apiPath } = require('appService/api');
const { inputBox: inputboxEvent, dropMenu: dropMenuEvent,checkbox: checkboxEvent} = require('components/config/event.json');


const addPost = {
  name: "add-post",

  template,

  data() {
    return {
      serverSetAction: apiPath.community.addPost,
      uploadImg: apiPath.common.uploadImg,
      topicUrl: apiPath.common.topic,
      brandUrl: apiPath.common.carBrand,
      cityUrl: apiPath.common.selectPcd,
      getVestUrl: apiPath.common.getVest,
      getLabelUrl:apiPath.common.getLabel,
      detailData: {
        postUser:'',
        belongTopic:'',
        contentDesc:'',
        brandName:[],
        postImgs:[],
        cityCode:'',
        provinceCode:'',
        groupLabel:''
      },
      groupLabel:[],
      topicList:[],
      brandList:[],
      allCarValue:'',
      comItems:[],
      prodList:[],
      cityList:[],
      hideCity:false,
      hideProv:false,
      cityObj:{},
      accountObj:{}, //用户ID与其应的城市码
      ajaxed:true
    }
  },
  route:{
    data(transition){
      
       ajaxHttp(this.cityUrl)
        .then(res => {
          console.log(res)
          let proAr = [];
          res.data.forEach( item => {
              proAr.push({'value':item.id, 'text': item.pname});
              this.cityObj[item.id] = this.formatCity(item.citys);
          })
          this.cityObj['0'] = [{'value':0, 'text': '请选择'}];
          proAr.unshift({'value':0, 'text': '请选择'})
          this.prodList = proAr;
        }).then( res => {
          this.getVestFn()
        })
        .catch(err => {
          tip(err);
        })
     transition.next();
    },
    waitForData: true
  },
  ready(){
   // this.getCity();
  },
  methods: {
    success(rtn){

      if(rtn.code==2){
        this.loginLose();
        return;
      }
      if(rtn.code==0){
        tip("新增成功");
        this.ajaxed=true;
        setTimeout(() => {
          this.$route.router.go({
              name: 'bbs-postlist'
            })
        },1500);
    }else{
      tip(rtn.error || '系统繁忙,请稍候在试')
    }
      
    },
    loginLose(){
          tip('登录信息过期');
          window.localStorage.removeItem('appBackToken');
          AB.TOKEN = null;

           let _hash = window.location.hash,
            _idx =_hash.indexOf("/");
            _hash = _hash.substring(_idx);
            if(_hash!="/login" && _hash.indexOf('/page') !=-1){
              sessionStorage.setItem("cbkURL",_hash);
            }

          
          setTimeout(()=>{
            this.$route.router.go({
              path: '/login'
            });
          }, 500);
    },
    getVestFn(val){
      if(val==-1 || val==""){return;}

      ajaxHttp(this.getVestUrl,{data:{'type':val}})
        .then(res => {
          let proAr = [];
          res.data.forEach( item => {
              proAr.push({'value':item.id, 'text': item.nickName});
              this.accountObj[item.id] = {'province': item.province,'city': item.city};
          })
          this.comItems = proAr;
        });

    },
    formatCity(arr){
      let _arr = [];
      arr.forEach(item => {
        _arr.push({'value':item.id,'text': item.cname});
      })
      return _arr;
    },
    beforeSubmit(){
      this.ajaxed = false;
    },
    addPostFn(){
      
      this.$refs.formArea.setAction(this.serverSetAction).submit()
    },
  },
  events:{
    
    [dropMenuEvent.menu.change](opt){
      let qName = opt.queryName;
      if(qName == 'prod'){
        let _cityVal = this.cityObj[opt.value];
       this.cityList = typeof _cityVal == 'undefined'? []: _cityVal;
       if(this.cityList.length==0){
        return;
       }/*
       this.hideCity = false;
       this.hideProv = false;*/
       this.detailData.provinceCode = opt.value;
       this.detailData.cityCode = this.cityList[0].value;
       return;
      }
      if(qName =='postUser'){
        let _val = this.$refs.userlist.value;
        if(_val=="" || _val==-1){return;}
        this.hideCity = false;
        this.hideProv = false;
        this.detailData.provinceCode = this.accountObj[_val].province;
        this.$nextTick(function(){
          this.detailData.cityCode = this.accountObj[_val].city;
        })
        
      }
    }
  },
  watch: {
    "detailData.brandName"(val, oldVal) {
      let len = this.brandList.length;
      if (val.length == len){
        this.allCarValue = [0];
      } else {
        this.allCarValue = [];
      }
    }
  },
  store
}

module.exports = addPost;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/common-post/post-add/post-add.js